import { createContext, useContext, type ReactNode } from "react";
import type { ReportsClient } from "./types";

const ReportsClientContext = createContext<ReportsClient | null>(null);

export const ReportsClientProvider = ({
  client,
  children,
}: {
  client: ReportsClient;
  children: ReactNode;
}) => (
  <ReportsClientContext.Provider value={client}>
    {children}
  </ReportsClientContext.Provider>
);

export const useReportsClient = (): ReportsClient => {
  const client = useContext(ReportsClientContext);
  if (!client)
    throw new Error(
      "useReportsClient must be used inside <ReportsClientProvider>",
    );
  return client;
};

/** For widgets outside the reports pages (e.g. the dialer hint): null when no client is provided. */
export const useOptionalReportsClient = (): ReportsClient | null =>
  useContext(ReportsClientContext);
